import { useEffect } from 'react';
import api from 'Redux/api/axiosInstance';

// While the app is open (even idle) ask the API every 45 s whether the account is still allowed to work.
// A deactivated user / company or an expired subscription answers 401 → the axios interceptor signs the user out.
export default function useSessionGuard(enabled) {
  useEffect(() => {
    if (!enabled) return undefined;
    const ping = () => {
      if (document.visibilityState === 'visible') api.get('Auth/session').catch(() => {});
    };
    const id = setInterval(ping, 45_000);
    document.addEventListener('visibilitychange', ping);
    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', ping);
    };
  }, [enabled]);
}
